import Glide from '@glidejs/glide';

// Glide carousel configuration
const GLIDE_CONFIG = {
  type: 'carousel',
  startAt: 0,
  perView: 4,
  autoplay: 2500,
  hoverpause: true,
  animationDuration: 800,
  gap: 30,
  breakpoints: {
    800: { perView: 3 },
    600: { perView: 2 },
  },
};

/**
 * Initialize Glide carousel if element exists
 * @returns {void}
 */
export const initGlideCarousel = () => {
  const glideElement = document.querySelector('.glide');

  if (!glideElement) {
    return;
  }

  try {
    new Glide('.glide', GLIDE_CONFIG).mount();
  } catch (error) {
    console.error('Failed to initialize Glide carousel:', error);
  }
};

export default initGlideCarousel;
